module.exports = __webpack_public_path__ + "img/pro_one_10.0a2dd8ef.jpg";